import { isApiError } from "./api.ts";

/** API のエラーを画面に出す文にする。個別の文が無いものは fallback */
export function errorMessage(error: unknown, fallback: string): string {
  if (!isApiError(error)) return fallback;
  switch (error.code) {
    case "NETWORK_ERROR":
      return "サーバーに接続できませんでした。通信環境を確認して、再度お試しください。";
    case "UNAUTHENTICATED":
    case "REAUTHENTICATION_REQUIRED":
      return "ログインの有効期限が切れました。もう一度ログインしてください。";
    case "TOO_MANY_REQUESTS":
      return error.retryAfterSeconds !== null
        ? `操作が続いたため受け付けられませんでした。${waitText(error.retryAfterSeconds)}待ってから再度お試しください。`
        : "操作が続いたため受け付けられませんでした。しばらく待ってから再度お試しください。";
    case "UPSTREAM_ERROR":
    case "INTERNAL_ERROR":
      return "処理中にエラーが発生しました。時間をおいて再度お試しください。";
    default:
      return fallback;
  }
}

function waitText(seconds: number): string {
  return seconds < 60 ? `${seconds} 秒ほど` : `${Math.ceil(seconds / 60)} 分ほど`;
}
